import {
  FORWARD_LOGIN_FAIL,
  FORWARD_LOGIN_SUCCESS,
  GET_AGENT_INFO,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT_ACTION,
  SET_ACTIVE_PROFILE,
  SET_AGENT_INFO,
  SET_TOKEN_LOGIN,
  TRIGGER_FORWARD_LOGIN,
  TRIGGER_LOGIN,
  GET_ROLES_AFTER_ACTIVE_PROFILE,
  SET_ROLES_AFTER_ACTIVE_PROFILE,
  SET_ALL_PROFILES_ROLES,
  GET_PERSONAL_DETAIL_AND_BUSINESS_INFORMATION,
  SET_PERSONAL_DETAIL_INFORMATION,
  SET_BUSINESS_INFORMATION,
  GET_IS_HOUSEHOLD,
  SET_IS_HOUSEHOLD,
  AUTHENTICATION_FORGET_PASSWORD,
  SET_FORGET_PASSWORD_FACTORS,
  SEND_OTP_FORGET_PASSWORD,
  SET_OTP_FORGET_PASSWORD,
  VERIFY_OTP_FORGET_PASSWORD,
  RESET_PASSWORD,
} from './constants';

export const triggerLogin = () => ({
  type: TRIGGER_LOGIN,
});

export const loginRequest = () => ({
  type: LOGIN_REQUEST,
});

export const loginSuccess = () => ({
  type: LOGIN_SUCCESS,
});

export const setTokenLogin = (payload) => ({
  type: SET_TOKEN_LOGIN,
  payload,
});

export const logoutAction = () => ({
  type: LOGOUT_ACTION,
});

export const setActiveProfile = (payload) => ({
  type: SET_ACTIVE_PROFILE,
  payload,
});

export const getAgentInfo = () => ({
  type: GET_AGENT_INFO,
});

export const setAgentInfo = (payload) => ({
  type: SET_AGENT_INFO,
  payload,
});

export const triggerForwardLogin = (payload) => ({
  type: TRIGGER_FORWARD_LOGIN,
  payload,
});

export const forwardLoginSuccess = () => ({
  type: FORWARD_LOGIN_SUCCESS,
});

export const forwardLoginFail = () => ({
  type: FORWARD_LOGIN_FAIL,
});

export const getRolesAfterActiveProfile = () => ({
  type: GET_ROLES_AFTER_ACTIVE_PROFILE,
});

export const setRolesAfterActiveProfile = (payload) => ({
  type: SET_ROLES_AFTER_ACTIVE_PROFILE,
  payload,
});

export const setAllProfilesRoles = (payload) => ({
  type: SET_ALL_PROFILES_ROLES,
  payload,
});

export const getPersonalDetailAndBusinessInformation = () => ({
  type: GET_PERSONAL_DETAIL_AND_BUSINESS_INFORMATION,
});

export const setPersonalDetailInformation = (payload) => ({
  type: SET_PERSONAL_DETAIL_INFORMATION,
  payload,
});

export const setBusinessInformation = (payload) => ({
  type: SET_BUSINESS_INFORMATION,
  payload,
});

export const checkIsHousehold = () => ({
  type: GET_IS_HOUSEHOLD,
});

export const setIsHousehold = (payload) => ({
  type: SET_IS_HOUSEHOLD,
  payload,
});

export const authenticationForgetPassword = (payload, callback) => ({
  type: AUTHENTICATION_FORGET_PASSWORD,
  payload,
  callback,
});

export const setForgetPasswordFactors = (payload) => ({
  type: SET_FORGET_PASSWORD_FACTORS,
  payload,
});

export const sendOtpForgetPassword = (payload, callback) => ({
  type: SEND_OTP_FORGET_PASSWORD,
  payload,
  callback,
});

export const setOtpForgetPassword = (payload) => ({
  type: SET_OTP_FORGET_PASSWORD,
  payload,
});

export const verifyOtpForgetPassword = (payload, callback) => ({
  type: VERIFY_OTP_FORGET_PASSWORD,
  payload,
  callback,
});

export const resetPassword = (payload, callback) => ({
  type: RESET_PASSWORD,
  payload,
  callback,
});
